import type { ConversationFeedback } from '../lib/api'
import { messageTurns } from './message-turn'

// 留意見入口該掛在哪、該輪已經留過哪幾則（#1446）。邏輯全放在這裡：
// ChatPage 載不進 jest（ai 是純 ESM），能測的只有這種獨立模組。

/** 整份對話的意見存成輪次 0（#1435）：真實輪次從 1 起跳，0 天然空著。 */
export const WHOLE_CONVERSATION_TURN = 0

/** 只看角色就夠，即時的 UIMessage 與重整後的投影都套得上。 */
interface RoleOnly {
  role: string
}

// 該輪自己留過的幾則，先留的在上面。🔴 沒有唯一索引也沒有防重複機制，
// 回顯是唯一能讓里長不重複講同樣的話的東西，所以它是必要的不是加分項。
export const feedbackForTurn = (
  feedback: ConversationFeedback[], turn: number,
): ConversationFeedback[] =>
  feedback
    .filter((entry) => entry.turn === turn)
    .sort((a, b) => a.createdAt.localeCompare(b.createdAt))

// 入口掛在每一輪的**最後一則**助理訊息下方，不是每一則訊息都有。
// 回傳 index → 輪次；還沒有助理回應的那一輪不出現，沒有東西可以評。
export const feedbackAnchors = (messages: RoleOnly[]): Map<number, number> => {
  const turns = messageTurns(messages)
  const lastAssistant = new Map<number, number>()
  messages.forEach((message, index) => {
    // 輪次 0 代表整份對話，那一則的入口在別處；助理訊息落在 0 只會是異常資料
    if (message.role === 'assistant' && turns[index] > 0) lastAssistant.set(turns[index], index)
  })
  const anchors = new Map<number, number>()
  lastAssistant.forEach((index, turn) => anchors.set(index, turn))
  return anchors
}
